import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export default function formatDateMaintenance(date) {
  return format(parseISO(date), "yyyy-MM-dd", {
    locale: ptBR,
  });
}
